import { render } from "./Index.vue?vue&type=template&id=33a2afcb"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=33a2afcb&lang=scss"
script.render = render

export default script